import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import * as icons from 'assets/icons';

const spriteFilename = `${process.env.APP_ASSETS_PUBLIC_PATH}sprite.${process.env.APP_VERSION}.svg`;

// SVG sprites with <use> inherit color through currentColor
// The fill prop sets the CSS color property, which is inherited by currentColor in SVG
const StyledSvg = styled.svg`
  ${({ $fill }) =>
    $fill &&
    `
    color: ${$fill} !important;
  `}
`;

const Icon = memo(({ name, fill, style, className, ...props }) => {
  const icon = icons[name];

  if (!icon) {
    return null;
  }

  const viewBoxArray = (icons[name].viewBox || '').split(' ');

  // Set color for currentColor inheritance in SVG
  const combinedStyle = fill ? { ...style, color: fill } : style;

  return (
    <StyledSvg
      viewBox={icon.viewBox}
      width={viewBoxArray[2]}
      height={viewBoxArray[3]}
      $fill={fill}
      style={combinedStyle}
      className={className}
      {...props}
    >
      <use xlinkHref={`${spriteFilename}#${icon.id}`} />
    </StyledSvg>
  );
});

Icon.propTypes = {
  name: PropTypes.string,
  fill: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
};

Icon.defaultProps = {
  name: '',
  fill: null,
  style: null,
  className: null,
};

export default Icon;
